/* Progressive scroll reveals; no library, layout reads inside setup only. */
(function(){
  'use strict';
  var selector='.sw-pj__heading,.sw-pj__feature,.sw-pj__card,.sw-pj__real-card,.sw-pj__faq-items details,.sw-pj__finish,.sw-category-showcase__card,.sw-spotlight,.sw-home-finale,.sw-product-story,.sw-collection-intro,.sw-lp__card,.sw-lp__visual,.product-card';
  if(!('IntersectionObserver' in window)||window.matchMedia('(prefers-reduced-motion: reduce)').matches||window.matchMedia('(max-width: 749px)').matches){return;}
  var observer=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(!entry.isIntersecting)return;
      observer.unobserve(entry.target);
      entry.target.classList.remove('sw-motion-pending');
      entry.target.classList.add('sw-motion-shown');
    });
  },{rootMargin:'0px 0px -20px 0px',threshold:0.04});
  function setup(root){
    var elements=root.querySelectorAll(selector);
    for(var i=0;i<elements.length;i++){
      var item=elements[i];
      if(item.dataset.swMotionSeen)continue;
      item.dataset.swMotionSeen='1';
      var rect=item.getBoundingClientRect();
      if(rect.top>window.innerHeight*0.86){
        item.classList.add('sw-motion-pending');
        observer.observe(item);
      }
    }
  }
  function boot(){setup(document);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',function(e){setup(e.target);});
})();

/* SW draft preview: preserve preview_theme_id when a product-card play badge opens its product. */
(function () {
  'use strict';
  var params = new URLSearchParams(window.location.search);
  var previewId = params.get('preview_theme_id');
  if (!previewId || !/^\d+$/.test(previewId)) return;

  function keepPreview(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var anchor = target.closest('a.sw-product-video-badge--link');
    if (!anchor) return;
    try {
      var url = new URL(anchor.href, window.location.href);
      if (url.origin !== window.location.origin) return;
      url.searchParams.set('preview_theme_id', previewId);
      anchor.href = url.toString();
    } catch (error) { /* Preserve native link behavior when URL is not valid. */ }
  }

  document.addEventListener('pointerover', keepPreview, { passive: true });
  document.addEventListener('focusin', keepPreview);
  document.addEventListener('click', keepPreview);
})();

/* Focus Shopify's existing video poster after a video-badge jump.
   Playback remains user-initiated through Horizon's native deferred-media control. */
(function () {
  'use strict';
  function focusOriginalVideo() {
    var match = /^#sw-product-videos-(\d+)$/.exec(window.location.hash);
    if (!match) return;
    var target = document.getElementById('sw-product-videos-' + match[1]);
    if (!target) return;
    var play = target.querySelector('deferred-media button[ref="deferredMediaPlayButton"]');
    if (!play || play.disabled) return;
    try { play.focus({ preventScroll: true }); }
    catch (_) { play.focus(); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', focusOriginalVideo, { once: true });
  } else focusOriginalVideo();
  window.addEventListener('hashchange', focusOriginalVideo);
})();


/* SW load the expanded product photos only after the customer asks for them. */
(function () {
  'use strict';
  function reveal(details) {
    if (!details.open) return;
    const template = details.querySelector('template[data-sw-extra-template]');
    const grid = details.querySelector('[data-sw-extra-grid]');
    if (!template || !grid) return;
    grid.append(template.content.cloneNode(true));
    template.remove();
  }
  document.addEventListener('toggle', function (event) {
    const details = event.target;
    if (details instanceof HTMLDetailsElement && details.matches('.sw-story-media__more')) {
      reveal(details);
    }
  }, true);
  function boot(root) {
    root.querySelectorAll('details.sw-story-media__more[open]').forEach(reveal);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
